import React, { useMemo } from "react";
import classes from "./header.module.scss";
import classNames from "classnames";
import { PUBLIC_URL } from "../../constants/common";

const Header = () => {
  const logoText = useMemo(() => {
    if (window.location.pathname === "/pdf-inspector") {
      return "PDF.co PDF Inspector";
    }

    return "PDF.co PDF/Edit/Add Helper";
  }, []);

  return (
    <div className={classNames(classes.HeaderWrap, "text-primary")}>
      <div className={classes.LeftWrap}>
        <div className={classes.LogoWrap}>
          <div className={classes.Logo}>
            <img src={`${PUBLIC_URL}/img/logo/header-logo.png`} />
          </div>
          <div className={classes.LogoText}>{logoText}</div>
        </div>
      </div>
      <div className={classes.LeftWrap}>
        <div
          className={classNames(classes.ReturnToTheDashboard, "text-primary")}
        >
          <a href="/">return to the dashboard</a>
        </div>
      </div>
    </div>
  );
};

export default Header;
